// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__T8xPJ","header":"PatientQuestionnaire_header__2KjM9","info":"PatientQuestionnaire_info__15Iew"};